
import RcDomainMap from "../../common/RcDomainMap.js";
import CompanyStats from './CompanyStats.js';

export default class CompanyStatsMap extends RcDomainMap {

  static MODEL_NAME = CompanyStats.MODEL_NAME + "Map";

  constructor(domain, data) {
    super(domain, data, CompanyStatsMap.MODEL_NAME);
  }

  copy() {
    var data = this._copy();
    return new CompanyStatsMap(this.domain, data);
  }

  list() {
    var values = [];
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getCompanyStats(key);
      values.push(item);
    }
    return values;
  }

  sum(identifier) {
    var keys = this.keys();
    var sum = 0;
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getCompanyStats(key);
      sum += item.get(identifier)
    }
    return sum;
  }

  sortByCreatedDateDesc() {
    return this.list().sort(function (a, b) {
      if (a.createdDate() > b.createdDate()) {
        return -1;
      }
      if (a.createdDate() < b.createdDate()) {
        return 1;
      }
      return 0;
    });
  }

  sortByCreatedDate() {
    return this.list().sort(function (a, b) {
      if (a.createdDate() < b.createdDate()) {
        return -1;
      }
      if (a.createdDate() > b.createdDate()) {
        return 1;
      }
      return 0;
    });
  }

  sortByInvoiceAmountDescRaw() {
    return this.list().sort(function (a, b) {
      if (a.amount() > b.amount()) {
        return -1;
      }
      if (a.amount() < b.amount()) {
        return 1;
      }
      return 0;
    });
  }

  sortByInspectionCountDesc() {
    return this.list().sort(function (a, b) {
      if (a.inspections() > b.inspections()) {
        return -1;
      }
      if (a.inspections() < b.inspections()) {
        return 1;
      }
      return 0;
    });
  }

  sortByTimesheetCountDesc() {
    return this.list().sort(function (a, b) {
      if (a.timesheets() > b.timesheets()) {
        return -1;
      }
      if (a.timesheets() < b.timesheets()) {
        return 1;
      }
      return 0;
    });
  }

  sortByEquipmentInspectionCountDesc() {
    return this.list().sort(function (a, b) {
      if (a.equipmentInspections() > b.equipmentInspections()) {
        return -1;
      }
      if (a.equipmentInspections() < b.equipmentInspections()) {
        return 1;
      }
      return 0;
    });
  }

  getCompanyStats(key) {
    var value = super.get(key);
    return new CompanyStats(this.domain, value);
  }

  sortByInspectionCountDescRaw() {
    var values = [];
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var data = super.get(key);
      values.push(data);
    }

    return values.sort(function (a, b) {
      if (a.inspectionCount > b.inspectionCount) {
        return -1;
      }
      if (a.inspectionCount < b.inspectionCount) {
        return 1;
      }
      return 0;
    });
  }

  sortByVehicleCountDescRaw() {
    var values = [];
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var data = super.get(key);
      values.push(data);
    }

    return values.sort(function (a, b) {
      if (a.vehicleCount > b.vehicleCount) {
        return -1;
      }
      if (a.vehicleCount < b.vehicleCount) {
        return 1;
      }
      return 0;
    });
  }

  sortByEmployeeCountDescRaw() {
    var values = [];
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var data = super.get(key);
      values.push(data);
    }

    return values.sort(function (a, b) {
      if (a.employeeCount > b.employeeCount) {
        return -1;
      }
      if (a.employeeCount < b.employeeCount) {
        return 1;
      }
      return 0;
    });
  }

  sortByTimesheetCountDescRaw() {
    var values = [];
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var data = super.get(key);
      values.push(data);
    }

    return values.sort(function (a, b) {
      if (a.timesheetCount > b.timesheetCount) {
        return -1;
      }
      if (a.timesheetCount < b.timesheetCount) {
        return 1;
      }
      return 0;
    });
  }

  sortByCheckInCountDescRaw() {
    var values = [];
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var data = super.get(key);
      values.push(data);
    }

    return values.sort(function (a, b) {
      if (a.checkInCount > b.checkInCount) {
        return -1;
      }
      if (a.checkInCount < b.checkInCount) {
        return 1;
      }
      return 0;
    });
  }
}